import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Use local storage for persistence

const persistConfig = {
    key: "root",
    storage, // Stores Redux state in local storage
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);

const store = configureStore({
    reducer: {
        auth: persistedAuthReducer, // Use persisted reducer
    },
});

export const persistor = persistStore(store); // Export persistor

export default store;
